export default {
  menu: 'Attributes',
  title: 'Attributes',

  general: {
    labels: {
      name: 'Title',
      slug: 'Slug',
      archive: 'Enable archives?',
      value: 'Value',
      values: 'Values:',
      insertValue: 'Add new value',
      editValue: 'Edit value',
      categories: 'Categories:',
      shops: 'Sites:',
      delete: 'Delete Attribute',
      withoutCategory: 'Without category'
    },

    validators: {
      name: 'Attribute name can not be longer than {num} characters',
      slug: 'Attribute slug can not be longer than {num} characters',
      value: 'Attribute value can not be more than {num} characters',
      valueSlug: 'Attribute value slug can not be more than {num} characters',
      nameRequired: 'Title field is required',
      valueRequired: 'Value field is required',
      slugRequired: 'Slug field is required',
      noChange: 'No changes have been made',
      delete: 'The desired feature can not be deleted'
    },

    notifications: {
      insert: {
        success: 'New feature successfully registered',
        error: 'Registering a new feature with an error'
      },
      insertValue: {
        success: 'New value saved successfully',
        error: 'Saved new value failed'
      },


      edit: {
        success: 'Feature successfully edited',
        error: 'Feature editing encountered error'
      },
      editValue: {
        success: 'Attribute value successfully updated',
        error: 'Updating new value failed'
      },

      delete: {
        success: 'The feature was successfully removed',
        error: 'Feature delete accompanied by error'
      },
      deleteValue: {
        success: 'The feature value was successfully removed',
        error: 'Feature value delete accompanied by error'
      },

      setProperties: {
        success: 'Feature prioritization was done successfully',
        error: 'Feature prioritization has error'
      },

      parseError: {
        slug: 'Slug has already been used'
      }
    },

    confirmations: {
      delete: {
        title: 'Delete feature',
        body: 'Are you sure you want to delete the feature {name}?'
      },
      deleteValue: {
        title: 'Delete feature value',
        body: 'Are you sure you want to delete the feature value {name}?'
      }
    }
  },

  list: {
    title: 'Attributes List',

    table: {
      header: {
        rowNumber: 'Row',
        name: 'Attribute name',
        values: 'Attribute values',
        categories: 'Attribute categories',
        productCount: 'Product count'
      }
    }
  },

  insert: {
    title: 'Add new feature'
  },

  edit: {
    title: 'Edit Feature'
  },

  profile: {
    title: 'Feature profile'
  },

  setProperties: {
    title: 'Attribute properties',

    statusTable: {
      loading: 'Loading ...',
      error: 'Error in receiving info'
    }
  },

  values: {
    table: {
      header: {
        row: 'Row',
        name: 'Name',
        slug: 'Slug',
        update: 'Update',
        delete: 'Delete',
        products: 'Products'
      }
    }
  },

  select: {
    table: {
      header: {
        select: 'Select',
        name: 'Attribute name',
        values: 'Attribute values'
      }
    }
  }
}
